import { HttpParams } from '@angular/common/http';
import { PaginationParams } from '../types';

export class PaginationParamsDto {
    readonly params: HttpParams;

    constructor(value: PaginationParams) {
        let params = new HttpParams().set('page', value.page).set('limit', value.limit);

        if (value.search) {
            params = params.set('search', value.search);
        }
        if (value.type) {
            const types = Array.isArray(value.type) ? value.type : [value.type];
            for (const type of types) {
                params = params.append('type[]', type);
            }
        }
        if (value.sort) {
            params = params.set('sort', value.sort);
        }
        if (value.order) {
            params = params.set('order', value.order);
        }

        this.params = params;
    }
}
